import AsyncStorage from "@react-native-async-storage/async-storage"
import { NotificationService } from "@Services/Notifications.Service"

const saveToken = async (value) => {
    try {
        await AsyncStorage.setItem("token", value)
    } catch (e) {
        // saving error
    }
}

const getToken = async () => {
    try {
        const value = await AsyncStorage.getItem("token")
        return value
    } catch (e) {
        // saving error
    }
}

const saveUser = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("user", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getUser = async () => {
    try {
        const jsonValue = await AsyncStorage.getItem("user")
        return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
        // saving error
    }
}

const saveNotificationStatus = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("notificationStatus", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getNotificationStatus = async () => {
    try {
        const jsonValue = await AsyncStorage.getItem("notificationStatus")
        return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
        // saving error
    }
}

const clearAll = async () => {
    try {
        await AsyncStorage.clear()
        await NotificationService.cancelNotificationSchedule()
    } catch (e) {
        // saving error
    }
}

const saveSurveysResponse = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("surveyResponse", jsonValue)
    } catch (e) {
        // saving error
    }
}

const saveLastAxeSurvey = async (lastVisitedAxeIndex) => {
    try {
        const jsonValue = JSON.stringify(lastVisitedAxeIndex)
        await AsyncStorage.setItem("lastVisitedAxeIndex", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getLastAxeSurvey = async () => {
    try {
        const value = await AsyncStorage.getItem("lastVisitedAxeIndex")
        return value
    } catch (e) {
        // saving error
    }
}

const saveLastAxeSurveyIndex = async (lastVisitedSurveyIndex) => {
    try {
        const jsonValue = JSON.stringify(lastVisitedSurveyIndex)
        await AsyncStorage.setItem("lastVisitedSurveyIndex", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getLastAxeSurveyIndex = async () => {
    try {
        const value = await AsyncStorage.getItem("lastVisitedSurveyIndex")
        return value
    } catch (e) {
        // saving error
    }
}

const saveReminderNotification = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("reminderNotifications", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getReminderNotification = async () => {
    try {
        const jsonValue = await AsyncStorage.getItem("reminderNotifications")
        return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
        // saving error
    }
}

const deleteReminderNotification = async () => {
    await AsyncStorage.removeItem("reminderNotifications")
}

const getSurveyResponse = async () => {
    try {
        const jsonValue = await AsyncStorage.getItem("surveyResponse")
        return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
        // saving error
    }
}

const resetSurveyResponse = async () => {
    try {
        return await AsyncStorage.removeItem("surveyResponse")
    } catch (e) {
        // saving error
    }
}

const setJustCreatedConstantDate = async (value) => {
    try {
        await AsyncStorage.setItem("constantDate", JSON.stringify(value))
    } catch (e) {
        // saving error
    }
}

const getJustCreatedConstantDate = async () => {
    try {
        const value = await AsyncStorage.getItem("constantDate")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

const setDiagEducatifRDV = async (value) => {
    try {
        await AsyncStorage.setItem("diagEducatif", JSON.stringify(value))
    } catch (e) {
        // saving error
    }
}

const getDiagEducatifRDV = async () => {
    try {
        const value = await AsyncStorage.getItem("diagEducatif")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

const setPlateformType = async (value) => {
    try {
        await AsyncStorage.setItem("plateformType", JSON.stringify(value))
    } catch (e) {
        // saving error
    }
}

const getPlateformType = async () => {
    try {
        const value = await AsyncStorage.getItem("plateformType")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

const saveConsentStatus = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("consentStatus", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getConsentStatus = async () => {
    try {
        const value = await AsyncStorage.getItem("consentStatus")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

const saveFirstTimeDEVisitingStatus = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("isFirstTimeDEVisitingStatus", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getFirstTimeDEVisitingStatus = async () => {
    try {
        const value = await AsyncStorage.getItem("isFirstTimeDEVisitingStatus")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

async function saveNoticeConsentStatus(value) {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("noticeConsentStatus", jsonValue)
    } catch (e) {
        // saving error
    }
}

async function getNoticeConsentStatus() {
    try {
        const value = await AsyncStorage.getItem("noticeConsentStatus")
        return JSON.parse(value)
    } catch (e) {
        // saving error
    }
}

const saveTestUser = async (value) => {
    try {
        const jsonValue = JSON.stringify(value)
        await AsyncStorage.setItem("testUser", jsonValue)
    } catch (e) {
        // saving error
    }
}

const getTestUser = async () => {
    try {
        const jsonValue = await AsyncStorage.getItem("testUser")
        return jsonValue != null ? JSON.parse(jsonValue) : null
    } catch (e) {
        // saving error
    }
}

export const LocalStorage = {
    saveLastAxeSurveyIndex,
    getLastAxeSurveyIndex,
    saveNoticeConsentStatus,
    getNoticeConsentStatus,
    clearAll,
    saveToken,
    getToken,
    saveUser,
    getUser,
    saveSurveysResponse,
    getSurveyResponse,
    saveReminderNotification,
    getReminderNotification,
    saveNotificationStatus,
    getNotificationStatus,
    setJustCreatedConstantDate,
    getJustCreatedConstantDate,
    setDiagEducatifRDV,
    getDiagEducatifRDV,
    saveLastAxeSurvey,
    getLastAxeSurvey,
    resetSurveyResponse,
    setPlateformType,
    getPlateformType,
    saveConsentStatus,
    getConsentStatus,
    saveFirstTimeDEVisitingStatus,
    getFirstTimeDEVisitingStatus,
    getTestUser,
    saveTestUser
}
